/* eslint import/no-unresolved: "off" */

if (process.env.NODE_ENV === 'production') {
    module.exports = require('./z-shop-ui.production.js');
} else {
    module.exports = require('./z-shop-ui.development.js');
}

